import { render, staticRenderFns } from "./collapsible-text.vue?vue&type=template&id=8a8a14fc&scoped=true"
import script from "./collapsible-text.vue?vue&type=script&lang=js"
export * from "./collapsible-text.vue?vue&type=script&lang=js"
import style0 from "./collapsible-text.vue?vue&type=style&index=0&id=8a8a14fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8a14fc",
  null
  
)

export default component.exports